
document.addEventListener("DOMContentLoaded", function () {
    const mediaItems = document.querySelectorAll(".main-product-clothes .product__media-item");
    const groupPrevBtn = document.querySelector(".main-product-clothes .group-prev");
    const groupNextBtn = document.querySelector(".main-product-clothes .group-next");

    if (!groupPrevBtn || !groupNextBtn) return;

    let activeIndex = 0;
    let groupSize = 5; // Number of items per group

    // Function to initialize active class
    function initializeActiveItems() {
        mediaItems.forEach(item => item.classList.remove("is-active")); // Clear all
        for (let i = 0; i < groupSize && i < mediaItems.length; i++) {
            mediaItems[i].classList.add("is-active");
        }
        updateButtons();
    }

    // Update active items for group navigation
    function updateActiveGroup(startIndex) {
        if (startIndex < 0 || startIndex >= mediaItems.length) return;

        // Clear all active states
        mediaItems.forEach(item => item.classList.remove("is-active"));

        // Set new active group
        for (let i = startIndex; i < startIndex + groupSize && i < mediaItems.length; i++) {
            mediaItems[i].classList.add("is-active");
        }
        activeIndex = startIndex;

        // Scroll to the first item in the new group
        mediaItems[startIndex].scrollIntoView({ behavior: "smooth", block: "nearest" });

        // Update button states
        updateButtons();
    }

    // Update button disable states
    function updateButtons() {
        groupPrevBtn.classList.toggle("disable", activeIndex === 0);
        groupNextBtn.classList.toggle("disable", activeIndex + groupSize >= mediaItems.length);
    }

    // Group Navigation (Next 5 / Prev 5)
    function updateGroup(next = true) {
        let newStartIndex = next ? activeIndex + groupSize : activeIndex - groupSize;
        if (newStartIndex < 0) newStartIndex = 0;
        if (newStartIndex > mediaItems.length - 1) newStartIndex = mediaItems.length - 1;

        updateActiveGroup(newStartIndex);
    }

    groupNextBtn.addEventListener("click", () => updateGroup(true));
    groupPrevBtn.addEventListener("click", () => updateGroup(false));

    // Initialize everything
    initializeActiveItems();
});



// ---------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
    const mediaList = document.querySelector(".main-product-parts .product__media-list");
    const mediaItems = document.querySelectorAll(".main-product-parts .product__media-item");
    const prevButton = document.querySelector(".main-product-parts .gallery-prev");
    const nextButton = document.querySelector(".main-product-parts .gallery-next");
    const dotsContainer = document.querySelector(".main-product-parts .slider-btns nav");

    if (!mediaList || !mediaItems.length || !prevButton || !nextButton || !dotsContainer) {
        console.warn("Gallery items, buttons, or dots container not found.");
        return;
    }

    let currentIndex = 0;

    // Generate dots dynamically based on media items
    dotsContainer.innerHTML = "";
    mediaItems.forEach((_, index) => {
        const dot = document.createElement("div");
        dot.classList.add("dot");
        dot.dataset.index = index;
        dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll(".dot");

    // Function to update navigation
    function updateNav(index) {
        mediaItems.forEach((item, i) => {
            item.classList.toggle("is-active", i === index);
        });
        dots.forEach((dot, i) => {
            dot.classList.toggle("active-dot", i === index);
        });
        currentIndex = index;
    }

    // Next Button Click
    nextButton.addEventListener("click", function () {
        currentIndex = (currentIndex + 1) % mediaItems.length;
        updateNav(currentIndex);
    });

    // Prev Button Click
    prevButton.addEventListener("click", function () {
        currentIndex = (currentIndex - 1 + mediaItems.length) % mediaItems.length;
        updateNav(currentIndex);
    });

    // Dot Click
    dots.forEach((dot) => {
        dot.addEventListener("click", function () {
            currentIndex = parseInt(dot.dataset.index);
            updateNav(currentIndex);
        });
    });

    // MutationObserver to detect external changes to `.is-active`
    const observer = new MutationObserver(() => {
        mediaItems.forEach((item, index) => {
            if (item.classList.contains("is-active")) {
                updateNav(index);
            }
        });
    });

    mediaItems.forEach((item) => {
        observer.observe(item, { attributes: true, attributeFilter: ["class"] });
    });

    // Initialize first active state
    mediaItems.forEach((item, index) => {
        if (item.classList.contains("is-active")) {
            currentIndex = index;
        }
    });
    updateNav(currentIndex);
});


// ---------------------video popup---------------------------------------

document.addEventListener("DOMContentLoaded", function () {
    let videoBlock = document.querySelector(".video-block");
    if (!videoBlock) return;

    let popup = document.querySelector(".pdp-video-popup");
    let closeBtn = document.querySelector(".close-popup");
    let youtubeIframe = document.querySelector(".pdp-video-popup iframe");

    let originalSrc = youtubeIframe.src; // Store the original iframe src

    videoBlock.addEventListener("click", function () {
        popup.style.display = "flex";
    });

    closeBtn.addEventListener("click", function () {
        popup.style.display = "none";
        youtubeIframe.src = ""; // Reset video
        youtubeIframe.src = originalSrc; // Restore video
    });

    // Close popup when clicking outside of content
    popup.addEventListener("click", function (event) {
        if (event.target === popup) {
            popup.style.display = "none";
            youtubeIframe.src = ""; // Reset video
            youtubeIframe.src = originalSrc; // Restore video
        }
    });
});


// -----------------------navigation change menus--------------------------

document.addEventListener("DOMContentLoaded", function () {
    // Restore the active menu state from sessionStorage
    // let storedMenu = sessionStorage.getItem("activeMenu");
    // let storedText = sessionStorage.getItem("activeMenuText");

    // if (storedMenu) {
    //     let targetElement = document.querySelector(`.cus-menu-home.${storedMenu}`);
    //     if (targetElement) {
    //         // First, remove active class from all menus to avoid duplicates
    //         document.querySelectorAll(".cus-menu-home").forEach(menu => menu.classList.remove("active"));
    //         targetElement.classList.add("active");
    //     }

    //     // Highlight the previously selected <li>
    //     let selectedLi = document.querySelector(`.mega-menu__list li[data-menu="${storedMenu}"]`);
    //     if (selectedLi) {
    //         document.querySelectorAll(".mega-menu__list li").forEach(li => li.classList.remove("active"));
    //         selectedLi.classList.add("active");

    //         // Update the summary text
    //         let parentMenu = selectedLi.closest(".change-menu-item");
    //         let summarySpan = parentMenu.querySelector(".summary span");
    //         if (summarySpan && storedText) {
    //             summarySpan.textContent = storedText;
    //         }
    //     }
    // }

    // Toggle .mega-menu__content when clicking .summary
    // document.querySelectorAll(".cus-menu-list-menu .change-menu-item .summary").forEach(summary => {
    //     summary.addEventListener("click", function (event) {
    //         event.stopPropagation();
    //         let menuContent = this.closest(".change-menu-item").querySelector(".mega-menu__content");
    //         menuContent.classList.toggle("active");
    //     });
    // });

    // Click outside to remove .active from .mega-menu__content
    document.addEventListener("click", function (event) {
        document.querySelectorAll(".mega-menu__content.active").forEach(menuContent => {
            if (!menuContent.closest(".change-menu-item").contains(event.target)) {
                menuContent.classList.remove("active");
            }
        });
    });

    // Handle menu item click
    // document.querySelectorAll(".mega-menu__content .mega-menu__list li").forEach(item => {

    // });

    // Handle menu item click (OLD)
    // document.querySelectorAll(".mega-menu__content .mega-menu__list li").forEach(item => {
    //     item.addEventListener("click", function () {
    //         let targetMenu = this.getAttribute("data-menu");
    //         let selectedText = this.textContent.trim();

    //         // Remove active class from all .cus-menu-home elements first
    //         document.querySelectorAll(".cus-menu-home").forEach(menu => menu.classList.remove("active"));

    //         // Add active class to the matching .cus-menu-home
    //         let targetElement = document.querySelector(`.cus-menu-home.${targetMenu}`);
    //         if (targetElement) {
    //             targetElement.classList.add("active");
    //         }

    //         // Remove active class from all <li> elements
    //         document.querySelectorAll(".mega-menu__list li").forEach(li => li.classList.remove("active"));

    //         // Add active class to the clicked <li>
    //         this.classList.add("active");

    //         // Update .summary span with the selected text
    //         let parentMenu = this.closest(".change-menu-item");
    //         let summarySpan = parentMenu.querySelector(".summary span");
    //         if (summarySpan) {
    //             summarySpan.textContent = selectedText;
    //         }

    //         // Store new selection in sessionStorage
    //         sessionStorage.setItem("activeMenu", targetMenu);
    //         sessionStorage.setItem("activeMenuText", selectedText);

    //         // Close the menu after selecting an item
    //         let menuContent = parentMenu.querySelector(".mega-menu__content");
    //         if (menuContent.classList.contains("active")) {
    //             menuContent.classList.remove("active");
    //         }
    //     });
    // });
});



// ----------------------------------------year vehicle popup---------------------------

document.addEventListener("DOMContentLoaded", function () {
    const vehicleButtons = document.querySelectorAll(".vehicle-btn");
    const vehiclePopup = document.getElementById("vehiclePopup");
    const closeButton = document.querySelector("#vehiclePopup .close-btn");
    const body = document.body;

    // Open popup when clicking vehicle buttons
    vehicleButtons.forEach(button => {
        button.addEventListener("click", function () {
            vehiclePopup.classList.add("show");
            body.classList.add("overlay-cls");
        });
    });

    // Close popup when clicking the close button
    closeButton.addEventListener("click", function () {
        closePopup();
    });

    // Event delegation to handle dynamically added elements
    document.body.addEventListener("click", function (event) {
        if (event.target.matches(".vehicle-popup .cm_vehicle-widget_button.button--primary")) {
            setTimeout(closePopup, 1000); // 1 second delay before closing
        }
    });

    // Function to close popup
    function closePopup() {
        vehiclePopup.classList.remove("show");
        body.classList.remove("overlay-cls");
    }
});


// ---------------- Subscribe Form -------------------
const shadowRootFormParent = document.querySelector('#Aai9xMlB5SUZyWkRMM__forms_inline_HWV4RD');
if (shadowRootFormParent) {
  const observer = new MutationObserver((_, obs) => {
    const shadowRootFormHost = shadowRootFormParent.querySelector('form-embed');
    const shadow = shadowRootFormHost?.shadowRoot;
    const target = shadow?.querySelector('section._formContainer_1q1d2_30');
    
    if (target && !target.dataset.styled) {
      Object.assign(target.style, {
        backgroundColor: '#111518',
        margin: '0',
      });

      if (window.innerWidth > 767) {
        target.style.paddingRight = '50px';
      }

      target.dataset.styled = 'true';
      obs.disconnect();
    }
  });
  
  observer.observe(shadowRootFormParent, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => observer.disconnect(), 10000); // just in case
}

function clearSelectedVehicle() {
    const isMobile = window.matchMedia('(max-width: 1024px)');
    let selectButton;
    if (isMobile) selectButton = document.querySelector("#cm_SingleVehicleGarageMobile");
    else selectButton = document.querySelector("#cm_SingleVehicleGarage");
    
    selectButton.querySelector(".clear-garage .cm_button").click();
}

// Clear Selected Vehicle (Fix iphone bag)
document.querySelector("#cm_VehicleWidgetDialog").addEventListener("click", function(event) {
     // Click clear button inside dialog
    if (event.target && event.target.matches('#cm_VehicleWidgetDialog .cm_vehicle-widget_button__clear')) {
        clearSelectedVehicle();
    }
});

function fixYouTubeIframes() {
    const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');

    iframes.forEach(function(iframe) {
        if (!iframe.hasAttribute('allowfullscreen')) {
            iframe.setAttribute('allowfullscreen', '');
        }

        let allowAttr = iframe.getAttribute('allow') || '';
        const requiredFeatures = [
            'accelerometer',
            'encrypted-media',
            'gyroscope',
            'picture-in-picture',
            'fullscreen'
        ];
        requiredFeatures.forEach(feature => {
            if (!allowAttr.includes(feature)) {
                allowAttr = allowAttr ? `${allowAttr}; ${feature}` : feature;
            }
        });
        iframe.setAttribute('allow', allowAttr);
        iframe.setAttribute('frameborder', '0');
    });
}



